/** The plain name of a measure on the Results page: the everyday words first, the technical term in brackets once where it helps (DESIGN §0). Falls back to the shared short label. */
import type { KpiId } from "@bsim/domain";
import { eveMeasureLabel } from "@bsim/engine";
import { kpiLabel, kpiShortLabel, riskRowLabel } from "../format/labels";

/** The measure the economic-value limit tests, named for the question it answers; its code lives in the glossary popover only. */
const EVE_NAME = eveMeasureLabel();

const PLAIN: Readonly<Partial<Record<KpiId, string>>> = {
  price: "Share price", nim: "Net interest margin", ncoRate: "Loans written off (net charge-off rate)", rotce: "Return on tangible equity",
  cet1Reported: "Reported CET1", cet1Marked: "Marked CET1", lcrLite: "Liquidity stress coverage",
  eve200: EVE_NAME, niiSensitivity: riskRowLabel("niiSensitivity"), efficiencyRatio: "Efficiency ratio",
  tbvps: "Tangible book value per share", ptbv: "Price to tangible book", eps: "Earnings per share",
};

export const plainLabel = (kpi: KpiId): string => PLAIN[kpi] ?? kpiShortLabel(kpi);

/** The measure's name inside a Results sentence or table: the shared label, except the one whose usual label is a code. */
export const measureName = (kpi: KpiId): string => (kpi === "eve200" ? EVE_NAME : kpiLabel(kpi));
export const measureShort = (kpi: KpiId): string => (kpi === "eve200" ? EVE_NAME : kpiShortLabel(kpi));

/** Points always print to two decimals wherever a player reads them: "+2.1 pts" becomes "+2.10 pts", "1.6 percentage points" becomes "1.60 percentage points". */
export const twoDecimalPoints = (text: string): string => text.replace(/(\d\.\d)(?= (?:percentage points|points|point|pts)\b)/g, "$10");
